// extracted by mini-css-extract-plugin
export default {"Head_Container":"HeadSection_Head_Container__5M1Ho","Head_Header":"HeadSection_Head_Header__kv2Vd"};